import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ETSY, SHOPIFY } from '../../../../constants/channels';
import ATTRIBUTE from '../../../../constants/attributes';

import actions from '../../../../actions';

export function category({ channel, preview }) {
  switch (channel) {
    case ETSY: {
      return {
        actions: [actions.bulkEdit.updateMenuForCategory(preview.get(ATTRIBUTE.CATEGORY))],
        payload: Map({ type: OPERATIONS[channel].CATEGORY, value: preview.get(ATTRIBUTE.CATEGORY) }),
      };
    }

    case SHOPIFY: {
      return {
        payload: Map({ type: OPERATIONS[channel].CATEGORY, value: preview.get(ATTRIBUTE.CATEGORY) }),
      };
    }

    default: {
      return {};
    }
  }
}
